import {
  ADD_PAGE,
  ADD_TILES,
  ADD_FLAG_IS_APP_VIEW,
  ADD_FLAG_VISITED_RENEWAL_PAGE,
  ADD_FLAG_EXIT_PAGE_POPUP_DISPLAYED,
  TOGGLE_BATTERY_REPLACE_REMOVED_POPUP,
  SET_REFRESH_VEHICLES_LIST,
} from 'constants/contentConstants';

export function addTileContent(tile, tileSet) {
  return {
    type: ADD_TILES,
    payload: tile,
    tileSet,
  };
}

export function addPage(page) {
  return {
    type: ADD_PAGE,
    id: page?.uid,
    page,
  };
}

export function setFlagIsAppView(bool) {
  return {
    type: ADD_FLAG_IS_APP_VIEW,
    payload: bool,
  };
}

export function setFlagVisitedRenewalPage(bool) {
  return {
    type: ADD_FLAG_VISITED_RENEWAL_PAGE,
    payload: bool,
  };
}

export function setFlagExitPagePopupDisplayed(bool) {
  return {
    type: ADD_FLAG_EXIT_PAGE_POPUP_DISPLAYED,
    payload: bool,
  };
}

export function toggleBatteryReplaceRemovedPopup(string) {
  return {
    type: TOGGLE_BATTERY_REPLACE_REMOVED_POPUP,
    payload: string,
  };
}

export function setRefreshVehiclesList(bool) {
  return {
    type: SET_REFRESH_VEHICLES_LIST,
    payload: bool,
  };
}
